(ns storrito.connect3.select-2fa-method
  (:require [storrito.connect3.common :as common]
            [storrito.util.link :as link]))

(def key->userfriendlyname
  {"totp" [:div.flex.flex-col.items-center.justify-center
           [:i.fas.fa-shield-alt.text-blue-500.text-2xl.mr-3]
           [:div.flex.flex-col
            [:span.font-semibold "Authentication App"]
            [:span.text-xs.text-gray-500 "Get your code from an authenticator app"]]]
   "backup_codes" [:div.flex.flex-col.items-center.justify-center
                   [:i.fas.fa-key.text-green-500.text-2xl.mr-3]
                  [:div.flex.flex-col
                   [:span.font-semibold "Backup Codes"]
                   [:span.text-xs.text-gray-500 "Use backup codes from your Instagram app"]]]
   "sms" [:div.flex.flex-col.items-center.justify-center
          [:i.fas.fa-sms.text-yellow-500.text-2xl.mr-3]
          [:div.flex.flex-col
           [:span.font-semibold "SMS"]
           [:span.text-xs.text-gray-500 "Get your code via SMS"]]]
   "email" [:div.flex.flex-col.items-center.justify-center
            [:i.fas.fa-envelope.text-pink-500.text-2xl.mr-3]
            [:div.flex.flex-col
             [:span.font-semibold "Email"]
             [:span.text-xs.text-gray-500 "Get your code via email"]]]
   "approve_from_another_device" [:div.flex.flex-col.items-center.justify-center
                                  [:i.fas.fa-mobile-alt.text-indigo-500.text-2xl.mr-3]
                                  [:div.flex.flex-col
                                   [:span.font-semibold "Instagram App Approval"]
                                   [:span.text-xs.text-gray-600.font-medium "Check your Instagram App and tap \"Approve\""]
                                   [:a.inline-block.mt-1.text-xs.text-blue-600.hover:underline.font-medium
                                    {:href (link/help-center-url "fd390648-13a9-47b3-affb-71a5aad2f636")
                                     :target "_blank"}
                                    [:i.fas.fa-question-circle.fa-sm.mr-1]
                                    "Need help?"]]]
   "auto-totp" [:div.flex.flex-col.items-center.justify-center
                [:i.fas.fa-robot.text-purple-500.text-2xl.mr-3]
                [:div.flex.flex-col.items-center.justify-center
                 [:span.font-semibold "Storrito Authentication"]
                 [:span.text-xs.text-gray-500 "Use the Storrito authentication"]]]
   "whatsapp" [:div.flex.flex-col.items-center.justify-center
               [:i.fa-brands.fa-whatsapp.text-green-500.text-2xl.mr-3]
               [:div.flex.flex-col.items-center.justify-center
                [:span.font-semibold "Whatsapp"]
                [:span.text-xs.text-gray-500 "Get your code via whatsapp"]]]
   })

(defn available-option
  [option]
  [:li
   [:button.w-full.bg-gray-50.hover:bg-blue-50.active:bg-blue-100.transition.transform.duration-200.shadow-sm.rounded-xl.p-5.mb-4.text-lg.font-semibold.text-gray-800.flex.items-center.justify-center.gap-3.focus:outline-none.focus:ring-2.focus:ring-blue-400
    {:type "button"
     :tabIndex 0
     :on {:click [[:store/assoc-in [:connect3 :2fa-verification-method] option]
                  [:connect3/send! {:2fa-verification-method option}]]}}
    (get key->userfriendlyname option)]])

(defn panel
  [state]
  (let [available-2fa-verification-methods (:available-methods state)]
    [:div.bg-white.shadow-xl.rounded-2xl.px-8.pt-10.pb-10.max-w-xl.w-full.mx-auto.flex.flex-col.items-center
     (common/instagram-logo)
     [:h2.text-2xl.font-bold.text-gray-900.mt-6.mb-2.text-center.w-full
      "2FA is enabled for your Instagram Account."]
     [:p.text-lg.text-gray-700.mb-8.text-center.w-full "Please select a "
      [:a.font-semibold.underline.text-blue-700.hover:text-blue-500
       {:target "_blank"
        :href (link/help-center-url "2f6eae84-ce12-410c-8d50-aa1425ca0e2c")}
       "2FA verification method"] ":"]
     ;; PHP answers a failed pick (e.g. "Instagram did not offer the
     ;; approval in the app for this login") with the picker again plus
     ;; an error-message. Without showing it the picker looked unchanged
     ;; and users picked the same method up to four times in a row.
     (common/error-message state)
     [:ul.w-full.mt-2.mb-2
      (map (fn [e] (available-option e))
           available-2fa-verification-methods)]]))

